// replaylink.ts — the standalone in-browser replay viewer (the wi-replay Pages project) and the link to
// it. A recording is loaded by its archive key via `?replay=<yyyy-mm-dd>/<gameId>.wirep` (the viewer's
// functions/r proxy reads the wi-replays R2 archive). Shared by the leaderboard profile's recent-games
// "PLAY" buttons (dom/leaderboard-controller.ts) and the MP end-of-game "VIEW REPLAY" option (web/main.ts).

export const kszReplayViewerUrl = 'https://replay.warfareincorporated.com';

/** The watch-replay link for an archived recording — the wi-replay viewer, loaded by archive key. */
export function replayViewerUrl(replayKey: string): string {
  return `${kszReplayViewerUrl}/?replay=${encodeURIComponent(replayKey)}`;
}

/** Open the in-browser replay viewer for a recording in a new tab (no-op without a key / a DOM). */
export function openReplayViewer(replayKey: string, openUrl?: (url: string) => void): void {
  if (!replayKey) return;
  const url = replayViewerUrl(replayKey);
  if (openUrl) {
    openUrl(url);
    return;
  }
  if (typeof window !== 'undefined') window.open(url, '_blank', 'noopener');
}
